<template>
  <v-main>
    <v-container
      class="fill-height"
      fluid
    >
      <v-row
      >
        <v-col cols="12" class="mx-auto" >
          <v-row
          >
            <v-col cols="4" class="ma-0 pa-0" >
          <v-card style="border: black">
            <v-card-text>
              <v-text-field
              v-model.number="a"
              type="number"
              >
              </v-text-field>
            </v-card-text>
          </v-card>
        </v-col>
            <v-col cols="4" class=" ma-0 pa-0" style="border: black">
              <v-card>
                <v-card-text>
                  <v-text-field
                    v-model.number="b"
                    type="number"
                    min="0"
                  >
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class=" ma-0 pa-0" style="border: black">
              <v-card flat>
                <v-card-text>Total:
                  <v-text-field
                    v-model.number="a_plus_b"
                    type="number"
                    min="0"
                  >
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="ma-0 pa-0" style="border: black">
              <v-card>
                <v-card-text>
                  <v-text-field
                    v-model.number="c"
                    type="number"
                    min="0"
                  >
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="ma-0 pa-0" style="border: black">
              <v-card>
                <v-card-text>
                  <v-text-field
                    v-model.number="d"
                    type="number"
                    min="0"
                  >
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class=" ma-0 pa-0" style="border: black">
              <v-card flat>
                <v-card-text>Total:
                  <v-text-field
                    v-model.number="c_plus_d"
                    type="number"
                    min="0"
                  >
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="ma-0 pa-0" style="border: black">
              <v-card flat>
                <v-card-text>
                  Total:
                  <v-text-field
                    v-model.number="a_plus_c"
                    type="number"
                    min="0"
                  >
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="ma-0 pa-0" style="border: black">
              <v-card flat>
                <v-card-text>
                  Total:
                  <v-text-field
                    v-model.number="b_plus_d"
                    type="number"
                    min="0"
                  >
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="ma-0 pa-0" style="border: black">
              <v-card flat>
                <v-card-text>
                  Overall Total:
                  {{overall_total}}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0" style="border: black">
            <v-card flat>
              <v-card-text>
               Odds Ratio: {{odds_ratio}}
                <p>Calculation: ({{a}} x {{d}}) / ({{b}} x {{c}})</p>
              </v-card-text>
            </v-card>
          </v-col>
            <v-col cols="12" class="ma-0 pa-0" style="border: black">
              <v-card flat>
                <v-card-text>
                Attributable Risk:  {{attributable_risk}}
                  <p>Calculation: (({{a}} / {{a_plus_b}}) - ({{c}} / {{c_plus_d}})) / ({{a}} / {{a_plus_b}})</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0" style="border: black">
              <v-card flat>
                <v-card-text>
                 Population Attributable Fraction:  {{paf}}
                  <p> as a percentage: {{paf*100}} %</p>
                  <p>Calculation: ({{a}} - (({{c}} / {{c_plus_d}}) * {{a_plus_b}})) / {{a_plus_c}}</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0" style="border: black">
              <v-card flat>
                <v-card-text>
                  Relative Risk:  {{rr}}
                  <p> as a percentage: {{rr*100}} %</p>
                  <p>Formula: A/(A+B)   /    C / (C+D)  </p>
                  <p>Calculation:({{a}}/{{a_plus_b}}) / ({{c}}/{{c_plus_d}}</p>
                </v-card-text>
              </v-card>
            </v-col>
      </v-row>
          <v-btn @click="AlltheMath">Fill In</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>

export default {
  name: 'Epi2x2',
  data: () => ({

    a: null,
    b: null,
    c: null,
    d: null,
    a_plus_b: null,
    a_plus_c: null,
    c_plus_d: null,
    b_plus_d: null,
    overall_total: null,

    odds_ratio: null,
    attributable_risk: null,
    paf: null,
    rr: null,

  }),
  methods: {
    FillRemainingSquare() {
      if ((this.a && this.b) && !this.a_plus_b) {
        this.a_plus_b = this.a + this.b;
      }
      if ((this.a && this.a_plus_b) && !this.b) {
        this.b = this.a_plus_b - this.a;
      }
      if ((this.b && this.a_plus_b) && !this.a) {
        this.a = this.a_plus_b - this.b;
      }
      if ((this.c && this.d) && !this.c_plus_d) {
        this.c_plus_d = this.c + this.d;
      }
      if ((this.c && this.c_plus_d) && !this.d) {
        this.d = this.c_plus_d - this.c;
      }
      if ((this.d && this.c_plus_d) && !this.c) {
        this.c = this.c_plus_d - this.d;
      }
      if ((this.a && this.c) && !this.a_plus_c) {
        this.a_plus_c = this.a + this.c;
      }
      if ((this.a && this.a_plus_c) && !this.c) {
        this.c = this.a_plus_c - this.a;
      }
      if ((this.c && this.a_plus_c) && !this.a) {
        this.a = this.a_plus_c - this.c;
      }
      if ((this.b && this.d) && !this.b_plus_d) {
        this.b_plus_d = this.b + this.d;
      }
      if ((this.b && this.b_plus_d) && !this.d) {
        this.d = this.b_plus_d - this.b;
      }
      if ((this.d && this.b_plus_d) && !this.b) {
        this.b = this.b_plus_d - this.d;
      }
      this.overall_total = this.a_plus_b + this.c_plus_d;
    },
    GetOddsRatio() {
      this.odds_ratio = (this.a * this.d) / (this.b * this.c);
    },
    GetAttributableRisk() {
      const value1 = (this.a / this.a_plus_b) - (this.c / this.c_plus_d);
      this.attributable_risk = value1 / (this.a / this.a_plus_b);
    },
    GetPAF() {
      const value1 = (this.c / this.c_plus_d) * this.a_plus_b;
      const value2 = (this.a - value1);
      this.paf = value2 / this.a_plus_c;
    },
    GetRR() {
      const value1 = this.a / this.a_plus_b;
      const value2 = this.c / this.c_plus_d;
      this.rr = value1 / value2;
    },

    AlltheMath() {
      this.FillRemainingSquare();
      this.GetOddsRatio();
      this.GetAttributableRisk();
      this.GetPAF();
      this.GetRR();
    },
  },
};

/*
#Just to visualize


#  Diseased       Not Diseased
+---------------------------+
  |            ||             |
  Exposed      |             ||             |
 |      a     ||     b       | a_plus_b
 |            ||             |
 |            ||             |
  +---------------------------+
  +---------------------------+
  |            ||             |
 |            ||             |
 Not Exposed  |      c     ||      d      | c_plus_d
|            ||             |
|            ||             |
 +---------------------------+
  #            a_plus_c      b_plus_d
*/

</script>

<style scoped>

</style>
